/* esm.sh - d3-dispatch@3.0.1 */
export * from "/*d3-dispatch@3.0.1/esnext/d3-dispatch.mjs";
